import React, { useRef, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useSnackbar } from 'material-ui-snackbar-provider';

import Modal from '../../modules/Modal';
import { deleteComposer } from '../../../api';
import { NOTIFICATION } from '../../../enums/ENUMS';
import styles from './DeleteComposerModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { getComposersThunk } from '../../../store/composers/composersSlice';

type TDeleteComposerModal = {
  composerId: string;
  open: boolean;
  switchModal: () => void;
};

const DeleteComposerModal: React.FC<TDeleteComposerModal> = ({ composerId, open, switchModal }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const { page, limit, sort, sortOption } = useAppSelector((state) => state.composersStore);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteComposer({ composerId });
      switchModal();
      dispatch(getComposersThunk({ page, limit, sort, sortOption }));
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_DELETED);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to delete this composer?</div>
        <div className={styles.form} onSubmit={handleDelete}>
          <div className={styles.actionBtns}>
            <OutlinedButton type="submit" kind="default" disabled={loading} onClick={handleDelete}>
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>
            <ContainedButton kind="purple" type="button" disabled={loading} onClick={switchModal}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteComposerModal;
